import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-FloorplanOverlayer" */'shared-components/components/SrpCard/components/FloorplanOverlayer'));
